<template>
  <div class="game_detail">
    <div class="game_ad" v-if="gameModel!=null">
      <img :src="gameModel.slides[0]" alt="">
    </div>

    <div class="game_info">
      <div class="game_icon" v-if="gameModel!=null">
        <img :src="gameModel.icon" alt="">
      </div>

      <div class="game_desc" v-if="gameModel!=null">
        <p class="title">{{ gameModel.name }}
        </p>
        <p class="extra"></p>
      </div>

      <div class="btn_open" @click="open()">{{$t("打开")}}</div>

      <div class="game_type">{{ type_name }}</div>

    </div>
    <!--    tab 切换标签-->
    <div id="tab">
      <div class="tab-bar clearfix">
        <a href="javascript:;"
           @click="tab(index)"
           v-for="(item,index) in items"
           :class="{active : index===curId}"
        >{{ item.item }}</a>
      </div>
    </div>
    <div class="tab-con game_desc1" v-show="curId==0" v-if="gameModel!=null">
      <mt-swipe :auto="3000">
        <mt-swipe-item class="swipe_item"
                       v-for="(item,index) in gameModel.slides" :key="index">
          <img class="slide_img" :src="item" alt="">
        </mt-swipe-item>
      </mt-swipe>
      <p class="title1">游戏简介</p>
      <p class="content">{{ gameModel.introduction }}</p>
    </div>

    <div class="tab-con comment_div" v-show="curId==1">
      <ul class="comment_list">
        <li class="item_comment">
          <img src="../../assets/img/avatar3.png" alt="" class="avatar">
          <span class="name">大壮</span>
          <div class="like_count"><img src="../../assets/img/like.png" alt=""><span>100</span></div>
          <p class="comment">味觉的记忆总是非常深刻，或许女孩子们对一家甜品店铺记 忆忧心，是一种幸福甜蜜的体会。</p>
        </li>
      </ul>

      <div class="bottom_input">
        <img src="../../assets/img/send_comment.png" alt="">
        <input type="text" :placeholder="$t('写下你的评论')">
      </div>
    </div>

    <div class="back-container" @click="back()">
      <img src="../../assets/img/coinDetail/ico_back_white.png" alt="">
    </div>

  </div>
</template>

<script>

export default {
  name: "GameDetail",
  components: {},
  data() {
    return {
      curId: 0,
      items: [
        {item: '详情'}
        // {item: '评论'}
      ],
      gameModel: null,
      type_name: ""
    }
  },
  mounted() {
    this.gameModel = this.$route.query.item
    this.type_name = this.$route.query.type
  },
  activated() {
    this.gameModel = this.$route.query.item
    this.type_name = this.$route.query.type
  },

  methods: {
    tab(index) {
      this.curId = index;
    },
    open(){
      // window.location.href = this.gameModel.url
    },
    back() {
      this.$router.back()
    }
  }

}
</script>

<style scoped lang="less">
.game_detail {
  height: 100%;
}

.game_ad {
  height: 207px;

  img {
    width: 100%;
    height: 207px;
  }
}

.game_info {
  height: 64px;
  overflow: hidden;
  position: relative;
  margin-top: 4px;

  .game_icon {
    width: 63px;
    height: 61px;
    margin-left: 8px;
    float: left;

    img {
      width: 63px;
      height: 61px;
    }
  }

  .game_desc {
    width: 200px;
    height: 64px;
    float: left;
    position: relative;

    .title {
      font-size: 12px;
      font-family: Microsoft YaHei UI;
      font-weight: bold;
      color: #000000;
      margin-left: 3px;
      margin-top: 14px;
    }

    .extra {
      font-size: 10px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #A7A7A7;
      margin-left: 3px;
      margin-top: 7px;
    }

  }

  .btn_open {
    width: 67px;
    height: 26px;
    background-image: url("../../assets/img/bg_open.png");
    background-size: 100%;
    margin-top: 12px;
    float: right;
    margin-right: 18px;

    text-align: center;
    font-size: 11px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 26px;
  }

  .game_type {
    height: 21px;
    border-radius: 10px;
    border: 2px #4184D2 solid;
    padding-left: 12px;
    padding-right: 12px;

    position: absolute;
    right: 100px;
    top: 13px;

    font-size: 10px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: #4184D2;
    line-height: 21px;
    text-align: center;
  }
}

#tab {
  margin: 0 auto;
}

.tab-bar a {
  float: left;
  width: 80px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  text-decoration: none;
  color: #A7A7A7;

  font-size: 12px;
  font-family: Microsoft YaHei UI;
  font-weight: bold;
}

.tab-bar .active {
  border-bottom: 2px #4184d2 solid;
  color: #4184d2;
}

//游戏详情
.game_desc1 {
  height: 100%;

  .mint-swipe {
    height: 200px;
  }

  .swipe_item {
    .slide_img {
      height: 200px;
      width: 100%;
      display: block;
    }
  }

  .title1 {
    font-size: 14px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: #000000;
    line-height: 52px;
    margin-left: 32px;
  }

  .content {
    font-size: 12px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: #A7A7A7;
    margin-left: 32px;
    margin-right: 30px;
  }
}

.comment_div {
  position: relative;
  height: 100%;

  //列表
  .item_comment {
    padding: 10px 26px;
    position: relative;

    .avatar {
      width: 39px;
      height: 39px;
    }

    .name {
      height: 14px;
      font-size: 14px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #608BBC;
      line-height: 18px;
      margin-left: 8px;
      position: absolute;
      top: 15px;
    }

    .like_count {
      float: right;

      img {
        width: 15px;
        height: 15px;
      }

      span {
        height: 8px;
        font-size: 10px;
        font-family: SourceHanSansCN;
        font-weight: 400;
        color: #BCBCBC;
        line-height: 18px;
        margin-left: 8px;
      }
    }

    .comment {
      font-size: 10px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #6B6B6B;
      line-height: 18px;
      margin-left: 48px;
      position: relative;
      top: -10px;
    }
  }


  //底部输入框
  .bottom_input {
    width: 100%;
    height: 49px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 1px rgba(127, 127, 127, 0.23);
    position: fixed;
    bottom: 0;

    img {
      width: 51px;
      height: 32px;
      float: right;
      margin-top: 11px;
      margin-right: 15px;
    }

    input {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      height: 30px;
      background-color: #E7E7E7;
      border-radius: 20px;
      margin-left: 20px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}

.back-container {
  width: 50px;
  height: 50px;
  position: fixed;
  left: 0;
  top: 0;

  img {
    width: 10px;
    height: 16px;
    display: block;
    margin: 0 auto;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
}

</style>